export default "__VITE_ASSET__B2n9cKo4__"